<template src="../../templates/security/login.pug" lang="pug"></template>

<style src="../../sass/security/login.sass" lang="sass" scoped></style>

<script>
import axios from 'axios'
import { required, minLength, email } from 'vuelidate/lib/validators'
import { mapMutations, mapGetters } from 'vuex'

export default {
    name: 'login',
    data() {
        return {
            email: '',
            password: '',
            codeError: null,
            inputOnFocus: false
        }
    },
    validations: {
        email: {
            required
        },
        password: {
            required,
            minLength: minLength(6)
        }
    },
    computed: {
        ...mapGetters(['isOnline', 'isLogged', 'isMobile'])
    },
    beforeMount() {
        if (this.isLogged) {
            this.$router.push('/dashboard')
        }
    },
    methods: {
        ...mapMutations(['setToken', 'resetSelectedFarm']),
        submitLogin() {
            const params = new URLSearchParams()
            params.append('_username', this.email)
            params.append('_password', this.password)
            const self = this
            let url = process.env.NODE_ENV === 'production' ? `/api/login_check` : process.env.VUE_APP_AXIOS_URL + `/api/login_check`
            axios
                .post(url, params)
                .then(response => {
                    self.setToken(response.data.token)
                    self.resetSelectedFarm()
                    self.$router.push('/dashboard')
                })
                .catch(response => {
                    self.error = true
                })
        },
        setFocus(bool) {
            if (this.isMobile) {
                this.inputOnFocus = bool
            }
        }
    }
}
</script>
